import { all, call, put, takeEvery } from 'redux-saga/effects'
import { t } from 'ttag'
import { addNotification } from '../../../common/notifications/NotificationActions'
import { INotification } from '../../../common/notifications/NotificationReducers'
import api from '../../../services/api.services'
import { getErrorMsg } from '../../../common/helpers/translations'
import {
  getCompanyInfo,
  getCompanyInfoSuccess,
  getCompanyInfoFail,
  updateCompanyInfo,
  updateCompanyInfoSuccess,
  updateCompanyInfoFail,
} from './CompanyAdminActions'
import { updateCompanyBrandLogo } from '../../../common/auth/authActions'

function* sagaGetCompanyInfo({ payload }: any) {
  try {
    const { companyId } = payload
    const response: any = yield call(api.auth.getCompanyInfo, { companyId })
    yield put({ type: String(getCompanyInfoSuccess), payload: response })
  } catch (e: any) {
    yield put({ type: String(getCompanyInfoFail) })
    const notification: INotification = {
      type: 'warning',
      content: getErrorMsg('getCompanyInfo'),
    }
    yield put({ type: String(addNotification), payload: notification })
  }
}

function* sagaUpdateCompanyInfo({ payload }: any) {
  try {
    yield call(api.auth.updateCompanyInfo, payload)
    yield put({ type: String(updateCompanyInfoSuccess) })

    // Update brand logo in auth state so navbar reflects the change
    yield put({
      type: String(updateCompanyBrandLogo),
      payload: { companyId: payload.companyId, brandLogoUrl: payload.brandLogoUrl || '' },
    })

    const notification: INotification = {
      type: 'success',
      content: t`Company info saved successfully.`,
    }
    yield put({ type: String(addNotification), payload: notification })

    // Reload company info to get the latest state
    yield put({ type: String(getCompanyInfo), payload: { companyId: payload.companyId } })
  } catch (e: any) {
    yield put({ type: String(updateCompanyInfoFail) })
    const notification: INotification = {
      type: 'warning',
      content:
        e.message && e.message !== 'No message has been provided by the server'
          ? e.message
          : getErrorMsg('updateCompanyInfo'),
    }
    yield put({ type: String(addNotification), payload: notification })
  }
}

export function* companyAdminSagas() {
  yield all([
    takeEvery(String(getCompanyInfo), sagaGetCompanyInfo),
    takeEvery(String(updateCompanyInfo), sagaUpdateCompanyInfo),
  ])
}
